import React, { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import { Button, Form, Input, Modal, Table, message } from "antd";
import {
  useGetBranchesQuery,
  useAddBranchMutation,
  useDeleteBranchMutation,
} from "../../../redux/Service/api";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Heading from "../../../Components/Heading/Heading";
import ServerError from "../../../Components/utils/ServerError";

interface Branch {
  BranchID: number;
  BranchName: string;
}

const { confirm } = Modal;

const Branches: React.FC = () => {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();

  const [addBranch, { isLoading }] = useAddBranchMutation();
  const [deleteBranch, { isLoading: delIsLoading }] = useDeleteBranchMutation();

  const {
    data: branchesData,
    isError: isBranchesError,
    isLoading: isBranchesLoading,
  } = useGetBranchesQuery(undefined);

  const branches: Branch[] = branchesData?.ResponseObject ?? [];

  const handleAddBranch = async () => {
    try {
      const values = await form.validateFields();
      await addBranch(values);
      message.success("تمت إضافة الفرع بنجاح");
      form.resetFields();
      setOpenModal(false);
    } catch (error) {
      console.error("خطأ أثناء إضافة الفرع:", error);
      message.error("فشل في إضافة الفرع. يرجى المحاولة مرة أخرى.");
    }
  };

  const handleDeleteBranch = (id: number) => {
    confirm({
      title: "هل أنت متأكد أنك تريد حذف هذا الفرع؟",
      icon: <ExclamationCircleFilled />,
      content: "بالضغط على موافق سيتم حذف الفرع بشكل دائم.",
      async onOk() {
        try {
          await deleteBranch(id);
          message.success("تم حذف الفرع بنجاح");
        } catch (error) {
          console.error(error);
          message.error("فشل في حذف الفرع.");
        }
      },
    });
  };

  const columns = [
    {
      title: "اسم الفرع",
      dataIndex: "BranchName",
      key: "BranchName",
    },
    {
      title: "الإجراءات",
      key: "actions",
      render: (_: any, branch: Branch) => (
        <Button
          type="text"
          icon={<DeleteFilled />}
          danger
          onClick={() => handleDeleteBranch(branch.BranchID)}
        />
      ),
    },
  ];

  return (
    <section className="p-4 section_padding mt-0 pt-0 relative">
      <Heading heading="الفروع" />

      {isBranchesError && <ServerError />}

      <div className="text-center my-3">
        <Button
          className="w-[150px]"
          type="primary"
          onClick={() => setOpenModal(true)}
        >
          إضافة فرع
        </Button>
      </div>

      <div className="mx-auto">
        <Table
          columns={columns}
          dataSource={branches}
          rowKey="BranchID"
          loading={isBranchesLoading || delIsLoading}
          pagination={{ pageSize: 5 }}
        />
      </div>

      <Modal
        title="إضافة فرع"
        centered
        open={openModal}
        onCancel={() => setOpenModal(false)}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleAddBranch}>
          <Form.Item
            label="اسم الفرع"
            name="BranchName"
            rules={[{ required: true, message: "يرجى إدخال اسم الفرع" }]}
          >
            <Input size="large" placeholder="أدخل اسم الفرع" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={isLoading} block>
            إضافة
          </Button>
        </Form>
      </Modal>
    </section>
  );
};

export default Branches;
